import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'

export default class Category extends React.Component {
   constructor(props) {
       super(props);
       this.state = {
         MenuCategory: [{name: "Kurma a..", link: "#"},{name: "Al-Qur'a..", link:"#"},
        {name: "Buku", link:"#"},{name: "K-13", link:"#"},{name:"Buku Is..", link:"#"}]
       }
   }

   remove = (data) => {
       const newMenuCategory = this.state.MenuCategory.filter(menu => {
           return menu !== data
       })

       this.setState({
            MenuCategory: [...newMenuCategory]
       })
   }


   render() {
       const {MenuCategory} = this.state
    return (
        <div className={`nav-category ${this.props.cCategroy}`}>
            {
                MenuCategory.map((data, i) => {
                    return (
                        <div key={i} className="category">     
                             <Link to={data.link}><p>{data.name}</p></Link>
                             <img onClick={() => this.remove(data)} src="asset/dashboard/icons/x-circle.svg" alt="x-circle" />
                        </div>
                       
                    )
                })
            }
        </div>
    )
        }
}
